<template>
  <div id="header">
    <div class="headerContainer">
      <div class="headerTitle">
        <div class="zwfw"></div>
        <div class="jzzimg">“金种子”企业智能化管理</div>
      </div>
      <div class="login_box" v-if="!isLogin">
        <div class="login" @click="login">登录</div>
      </div>
      <div class="user_box" v-if="isLogin">
        <template v-if="backHomeShow">
          <span class="hov" @click="$router.push('/')">首页</span>
          <font>|</font>
        </template>
        <span class="username" :title="userInfo.nickname">{{userInfo.nickname}}</span>
        <font v-if="isLogin">|</font>
        <span
          v-if="isLogin"
          class="hov center"
          @click="goUserCenter"
        >用户中心</span>
        <font>|</font>
        <span class="hov" @click="loginout">退出</span>
        <font>|</font>
        <span class="hov" @click="openNew('https://zscq.zjamr.zj.gov.cn/login.html')">后台管理</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/api/index";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      isLogin: false,
      userInfo: {},
      appUserType: "",
      backHomeShow:true
    };
  },
  created() {
    if (localStorage.getItem("access_token")) {
      getUserInfo().then(res => {
        this.userInfo = res.data;
        this.appUserType = res.data.appUserType;
        this.SET_APPUSERTYPE(res.data.appUserType);
        this.isLogin = true;
      });
    }
    if(this.$route.fullPath == '/'){
      this.backHomeShow = false
    }else {
      this.backHomeShow = true
    }
    
  },
  methods: {
    ...mapMutations(["SET_APPUSERTYPE"]),
    ...mapActions(["deleteCommonDataAction"]),
    loginout() {
      this.deleteCommonDataAction();
      this.isLogin = false;
      window.open('https://portal.zjzwfw.gov.cn/uc/unifiedLogout');
      // if (this.appUserType == "UTR_SINGER") {
      //   window.open(
      //     "https://puser.zjzwfw.gov.cn/sso/newusp.do?action=logout&servicecode=zjzscqyjs",
      //     "_blank"
      //   );
      // } else {
      //   window.open(
      //     `http://esso.zjzwfw.gov.cn/opensso/UI/Logout?goto=https://oauth.zjzwfw.gov.cn/oauth/logout.do?redirect=${window.location.href}`,
      //     "_blank"
      //   );
      // }
    },
    goTo(path) {
      this.$router.push({
        path: path
      });
    },
    openNew(path) {
      window.open(path, "_blank");
    },
    login() {
      this.isLogin = false;
      this.$common.jzzlogin();
      // window.open(`${process.env.VUE_APP_DOMAINNAME}/cms/goDestAddress?url=${Base64.encode(window.location.href)}&mod=${encodeURI('金种子')}`)
    },
    goUserCenter(){
      if(this.appUserType == 'UTR_COMPANY'){
        this.$router.push('/usercenter/applyHistory')
      }else if(this.appUserType == "UTR_SINGER"){
        this.$router.push('/usercenter/objection')
      }
    }
  }
};
</script>
<style scoped lang="less">
#header {
  background-color: #fff;
}
.headerContainer {
  width: 1200px;
  margin: 0 auto;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerTitle {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  font-size: 30px;
  letter-spacing: 2px;
  align-items: center;
}
.headerTitle .zwfw{
  width: 400px;
  height: 91px;
  background: url('../assets/zwfw.png') no-repeat;
  background-size: 100% 100%;
  display: inline-block;
}
.jzzimg {
  margin-left: 10px;
}
.login_box {
  display: flex;
  justify-content: space-between;
}
.login_box .login {
  padding: 5px 30px;
  box-sizing: border-box;
  border: 1px solid #3f93f6;
  background-color: #fff;
  color: #3f93f6;
  border-radius: 16.5px;
  cursor: pointer;
}
.login_box .register {
  padding: 5px 30px;
  box-sizing: border-box;
  background-color: #3f93f6;
  color: #fff;
  border-radius: 16.5px;
  margin-left: 20px;
  cursor: pointer;
}

.container {
  width: 100%;
  background-color: #f5f6fa;
}
.container_main {
  width: 1200px;
  margin: 0 auto;
  border-bottom: 1px solid #f5f6fa;
}
#footer {
  width: 100%;
  height: 98px;
  background-color: #3f93f6;
}
.footer_container {
  max-width: 1200px;
  margin: 0 auto;
  height: 98px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.user_box {
  color: #888;
  display: flex;
  align-items: center;
  font {
    margin: 0 5px;
  }
  .username {
    display: inline-block;
    max-width: 150px;
    .line_1();
  }
  span.hov:hover {
    color: #409eff;
    cursor: pointer;
  }
  span.center {
    color: #409eff;
  }
}
</style>